/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface StatusResponse {
    /** @format date-time */
    timestamp: string;
    isUp: boolean;
    assemblyVersion?: string | null;
    application?: string | null;
    environment?: string | null;
}

export interface Calculation {
    /** Does the Plan associated with this calculation has a promotion (eg: reduced rate for a specific time.). */
    hasPromo: boolean;
    /** What kind loan this is (for example, standard installment; no payment and no interest if paid in full, etc..) */
    planType?: string | null;
    /** How the provider refers to the plan associated with this calculation. */
    planNumber?: string | null;
    /**
     * The amount used in the request to create this calculation response.
     * @format decimal
     */
    loanAmount: number;
    /**
     * The total amount expected to be paid for the loan.
     * @format decimal
     */
    totalAmount?: number | null;
    /**
     * Gets or sets the amortization period, typically expressed in months.
     * @format int32
     */
    amortization: number;
    /** Gets or sets the frequency at which payments are made.` */
    paymentFrequency: PaymentFrequency;
    /**
     * Default (non-promo) APR rate, in percent points (ex: 11.99)
     * @format decimal
     */
    defaultRate: number;
    /**
     * The monthly payment (excluding the promotional incentive).
     * @format decimal
     */
    defaultMonthlyPayment: number;
    /**
     * The loan term, in months (ex: 72 months).
     * @format int32
     */
    defaultTerms: number;
    /**
     * The promo APR rate, in percent points (ex: 9.75)
     * @format decimal
     */
    promotionalRate: number;
    /**
     * The monthly payment (during the promotional incentive).
     * @format decimal
     */
    promotionalMonthlyPayment: number;
    /**
     * How long the promotional period lasts, in months.
     * @format int32
     */
    promotionalTerms: number;
    /** Whether this calculation be used to apply for a loan. */
    eligibleForApplication: boolean;
    /**
     * The minimum loan amount for the plan used for this calculation.
     * @format decimal
     */
    minLoanAmount: number;
    /**
     * The maximum loan amount for the plan used for this calculation.
     * @format decimal
     */
    maxLoanAmount: number;
    /** Provider-supplied description of the plan. Example: "10 year - 11.99% without Autopay" */
    description?: string | null;
    /**
     * Disclaimer information for the specific calculation element/plan. This should be easily viewable by the user
     * when displaying "As low as $__/mo" or when showing the plans selector.
     */
    disclaimerText?: string | null;
    /**
     * Disclosure information for the aggregate calculation process. A disclosure is shown right before
     * the user submits the loan application, and should not be shown when presenting plans or
     * financing options.
     */
    disclosureText?: string | null;
    /**
     * Displays best case total amount for plans that have promotional terms
     * @format decimal
     */
    promotionalTotalAmount?: number | null;
    /** A standardized, customer-friendly description of the plan. */
    displayDescription?: string | null;
    /**
     * Complete formatted financing terms including payment details, description, disclaimers, and disclosures
     * based on provider-specific business rules for rendering in UI.
     */
    financingTerms?: string | null;
    /** The payment structure for the plan. */
    paymentStructure: PaymentStructure;
    /**
     * Indicates whether this calculation has the lowest payment amount among all calculations
     * in the same request.
     */
    hasLowestPayment?: boolean | null;
    /**
     * Indicates whether this calculation has the lowest APR among all calculations
     * in the same request.
     */
    hasLowestRate?: boolean | null;
    /**
     * Suggested monthly payment to pay off the loan within the promotional period.
     * @format decimal
     */
    suggestedMonthlyPayment?: number | null;
    /**
     * The suggested loan term, in months (ex: 6 months).
     * @format int32
     */
    suggestedTerms?: number | null;
    /**
     * Provider-assigned external identifier for the plan, used to resolve the merchant MID.
     * Null when the rule uses the tenant's default MID.
     */
    merchantId?: string | null;
    /** Human-readable name of the MID associated with this calculation's plan. */
    merchantName?: string | null;
    /**
     * The identifier of the provider that answered this calculation (e.g. "affirm", "servicefinance").
     * Consumers should use this to determine which provider icon and branding to display.
     */
    providerName?: string | null;
}

/** Represents the frequency of loan payments */
export enum PaymentFrequency {
    NotSet = 'notSet',
    Weekly = 'weekly',
    BiWeekly = 'biWeekly',
    Monthly = 'monthly',
}

export enum PaymentStructure {
    NotSet = 'notSet',
    StandardInstallment = 'standardInstallment',
    NoInterest = 'noInterest',
    MixedInterest = 'mixedInterest',
    DeferredInterest = 'deferredInterest',
    DeferredInterestAndPrincipal = 'deferredInterestAndPrincipal',
    Promotional = 'promotional',
}

export interface ErrorInfo {
    errorCode?: string | null;
    description?: string | null;
    invalidParameter?: string | null;
    invalidValue?: string | null;
    failedSource: FailedStatusSource;
}

export enum FailedStatusSource {
    NotSet = 'notSet',
    Provider = 'provider',
    UserInput = 'userInput',
    Backend = 'backend',
}

export interface SelectedImprovements {
    improvements?: string[] | null;
}

export interface TenantAccountBase {
    providerName?: string | null;
    generalProviderName?: string | null;
    defaultAccount?: Account | null;
    busAccounts?: BusAccount[] | null;
    merchantAccounts?: MerchantAccount[] | null;
    contactEmails?: string[] | null;
    properties?: Record<string, string>;
    /** Business units for which this provider is disabled for the tenant. */
    disabledBUs?: string[] | null;
}

export interface Account {
    externalId?: string | null;
    merchantAccounts?: MerchantAccount[] | null;
}

export interface MerchantAccount {
    merchantId?: string | null;
    name?: string | null;
    isDefault: boolean;
}

export interface BusAccount {
    account?: Account | null;
    businessUnits?: string[] | null;
}

/** Represents a financing plan available from a provider. */
export interface Plan {
    /** Plan number */
    planNumber?: string | null;
    /** Plan type. */
    type?: string | null;
    /** Plan description. */
    description?: string | null;
    /** Plan APR */
    apr?: string | null;
    /** Estimated payment factor showing the factor percentage or the promo factor percentage along with the factor one. */
    estimatedPaymentFactor?: string | null;
    /**
     * Plan term in months
     * @format int32
     */
    term?: number | null;
    /**
     * Contractor fee
     * @format decimal
     */
    contractorFee?: number | null;
    /**
     * Promo payment, if any
     * @format decimal
     */
    promoPayment?: number | null;
    /**
     * Promo months, if any
     * @format int32
     */
    promoMonths?: number | null;
    /**
     * Normal payment in USD
     * @format decimal
     */
    normalPayment?: number | null;
    /**
     * Normal months
     * @format int32
     */
    normalMonths?: number | null;
    /**
     * Minimum financing amount.
     * @format decimal
     */
    minAmount?: number | null;
    /**
     * Maximum financing amount.
     * @format decimal
     */
    maxAmount?: number | null;
    /** Amortizations available for each plan, used by financeit */
    amortizations?: number[] | null;
    /** Disclaimer associated with the plan. */
    disclaimerText?: string | null;
    /** The time window in months that the customer typically has to make a purchase after approved for a loan. */
    purchaseWindowMonths?: string | null;
    /** Selected amortization period for the loan. Currently only used by FinanceIt provider. */
    amortization?: string | null;
    /** Selected payment frequency for the loan. Currently only used by FinanceIt provider. */
    paymentFrequency?: string | null;
}

export interface RuleRecommendation {
    tenantId?: string | null;
    providerName?: string | null;
    businessUnitId?: string | null;
    merchantId?: string | null;
    recommendations?: RuleRecommendationForBusinessGoal[] | null;
    /** @format date-time */
    createdOn: string;
    /** @format date-time */
    lastUpdatedOn: string;
}

export interface RuleRecommendationForBusinessGoal {
    businessGoal?: string | null;
    tiers?: TierRecommendation[] | null;
    metrics?: Record<string, number>;
}

export interface TierRecommendation {
    /** @format decimal */
    minimumSpend: number;
    /** @format decimal */
    maximumSpend?: number | null;
    planNumbers?: string[] | null;
    defaultPlanNumber?: string | null;
}

export interface TriggerRuleRecommendation {
    tenantId?: string | null;
    businessUnitId?: string | null;
    providerName?: string | null;
    states?: string[] | null;
    improvement?: string | null;
}

export interface Rule {
    id?: string | null;
    name?: string | null;
    tenantId?: string | null;
    driverIds?: string[] | null;
    states?: string[] | null;
    tiers?: Tier[] | null;
    category: RuleCategory;
    financingProvider?: string | null;
    hasDefaultTier: boolean;
    improvementTypes?: string[] | null;
    /** @format date-time */
    lastUpdated: string;
    /** @format date-time */
    createdOn: string;
    generatedByPlanOptimizer: boolean;
    planOptimizerFinancingStrategy?: string | null;
    source: RuleSource;
    lastModifiedByUser?: string | null;
    planNumbers?: string[] | null;
    isUneditedPlanOptimizerSuggestion: boolean;
    /**
     * Provider-assigned merchant identifier for the rule, used to resolve the merchant MID.
     * Null when the rule uses the tenant's default MID.
     */
    merchantId?: string | null;
}

export interface Tier {
    /** @format decimal */
    minimumSpend: number;
    /** @format decimal */
    maximumSpend?: number | null;
    plans?: TierPlan[] | null;
    planNumbers?: string[] | null;
    defaultPlanNumber?: string | null;
    recommendedBy?: string | null;
}

export interface TierPlan {
    planNumber?: string | null;
    /** @format int32 */
    amortization?: number | null;
}

export enum RuleCategory {
    Default = 'default',
    BusinessUnit = 'businessUnit',
}

export enum RuleSource {
    Unknown = 'unknown',
    PlanOptimizer = 'planOptimizer',
    PlanOptimizerAndModifiedByUser = 'planOptimizerAndModifiedByUser',
    StartFromScratch = 'startFromScratch',
}

export type CreateRule = Rule & object;

export type UpdateRule = Rule & object;

export type MetricsExportMetricsAsInSampleData = any;

export type MetricsExportMetricsAsInDocsData = any;

export type StatusGetData = StatusResponse;

export type StatusGet2Data = StatusResponse;

export type StatusMetricsData = any;

export type StatusMetrics2Data = any;

export interface CalculationsGetCalculationsParams {
    /** The financing provider name */
    providerName: string | null;
    /** The tenant ID */
    tenantId: string | null;
    /** The business unit ID */
    buId?: string | null;
    /**
     * The loan amount to calculate for
     * @format decimal
     */
    amount: number;
    /** The state for the financing calculation */
    state?: string | null;
    /** Whether to return all plans or just the default plan */
    allPlans: boolean;
    /** Specific list of plans to calculate for */
    planList?: string[] | null;
    /** The improvement type for the loan */
    improvementType?: string | null;
    /**
     * Determines whether to use additional promotions or not. depending on the provider it can affect description
     * and rates.
     *
     * @default true
     */
    useAdditionalPromotions: boolean;
    /**
     * Optional payment frequency for loan calculations. Only used by FinanceIt provider.
     * Expected values: "weekly", "bi-weekly", "monthly", "all", or null.
     *
     */
    paymentFrequency?: string | null;
    merchantId?: string | null;
    /**
     * Legacy parameter kept for backwards compatibility with older clients that call this endpoint
     * with providerName=General&generalProviderName=X. New callers should pass the provider
     * directly as providerName=X.
     *
     */
    generalProviderName?: string | null;
}

export type CalculationsGetCalculationsData = Calculation[];

export type CalculationsGetCalculationsError = ErrorInfo[];

export interface CalculationsGetCalculations2Params {
    /** The financing provider name */
    providerName: string | null;
    /** The tenant ID */
    tenantId: string | null;
    /** The business unit ID */
    buId?: string | null;
    /**
     * The loan amount to calculate for
     * @format decimal
     */
    amount: number;
    /** The state for the financing calculation */
    state?: string | null;
    /** Whether to return all plans or just the default plan */
    allPlans: boolean;
    /** Specific list of plans to calculate for */
    planList?: string[] | null;
    /** The improvement type for the loan */
    improvementType?: string | null;
    /**
     * Determines whether to use additional promotions or not. depending on the provider it can affect description
     * and rates.
     *
     * @default true
     */
    useAdditionalPromotions: boolean;
    /**
     * Optional payment frequency for loan calculations. Only used by FinanceIt provider.
     * Expected values: "weekly", "bi-weekly", "monthly", "all", or null.
     *
     */
    paymentFrequency?: string | null;
    merchantId?: string | null;
    /**
     * Legacy parameter kept for backwards compatibility with older clients that call this endpoint
     * with providerName=General&generalProviderName=X. New callers should pass the provider
     * directly as providerName=X.
     *
     */
    generalProviderName?: string | null;
}

export type CalculationsGetCalculations2Data = Calculation[];

export type CalculationsGetCalculations2Error = ErrorInfo[];

export interface ImprovementsGetSelectedImprovementsParams {
    tenantId: string | null;
    providerName: string | null;
    businessUnitId?: string | null;
}

export type ImprovementsGetSelectedImprovementsData = SelectedImprovements;

export interface AccountsSaveAccountParams {
    providerName?: string | null;
    tenantId: string;
}

export type AccountsSaveAccountData = any;

export type AccountsSaveAccountError = ErrorInfo[];

export interface ProvidersGetPlansParams {
    /** The tenant ID. */
    tenantId?: string | null;
    /** Optional. List of business unit IDs (e.g., businessUnits=123&businessUnits=456). */
    businessUnits?: string[] | null;
    /** Optional. List of state codes (e.g., states=CA&states=TX&states=NY). */
    states?: string[] | null;
    /** Optional. The improvement type for filtering plans. */
    improvement?: string | null;
    /**
     * Optional. Whether to include additional promotions. Defaults to true.
     * @default true
     */
    useAdditionalPromotions: boolean;
    /**
     * Optional. When true, bypasses the cache and fetches fresh data from the provider.
     * @default false
     */
    noCache: boolean;
    /** Optional. Merchant account ID to scope plans to a specific MID. */
    merchantId?: string | null;
    /** Name of the financing provider (e.g., Synchrony, GreenSky, GoodLeap). */
    providerName: string;
}

export type ProvidersGetPlansData = Plan[];

export type ProvidersGetPlansError = ErrorInfo[];

export interface RuleRecommendationsGetRuleRecommendationsParams {
    tenantId?: string | null;
    providerName?: string | null;
    buId?: string | null;
    merchantId?: string | null;
}

export type RuleRecommendationsGetRuleRecommendationsData = RuleRecommendation[];

export type RuleRecommendationsTriggerRuleRecommendationsData = any;

export type RuleRecommendationsTriggerRuleRecommendationsError = ErrorInfo[];

export type RuleRecommendationsUpsertRuleRecommendationsPayload = RuleRecommendation[];

export type RuleRecommendationsUpsertRuleRecommendationsData = RuleRecommendation[];

export type RuleRecommendationsUpsertRuleRecommendationsError = ErrorInfo[];

export interface RulesGetRulesParams {
    tenantId?: string | null;
    providerName?: string | null;
    merchantId?: string | null;
}

export type RulesGetRulesData = Rule[];

export type RulesCreateRuleNewData = Rule;

export type RulesCreateRuleNewError = ErrorInfo[];

export interface RulesGetRules2Params {
    tenantId?: string | null;
    providerName?: string | null;
    merchantId?: string | null;
}

export type RulesGetRules2Data = Rule[];

export type RulesCreateRuleNew2Data = Rule;

export type RulesCreateRuleNew2Error = ErrorInfo[];

export type RulesGetRuleNewData = Rule;

export type RulesUpdateRuleNewData = any;

export type RulesUpdateRuleNewError = ErrorInfo[];

export type RulesDeleteRuleNewData = any;

export type RulesGetRuleNew2Data = Rule;

export type RulesUpdateRuleNew2Data = any;

export type RulesUpdateRuleNew2Error = ErrorInfo[];

export type RulesDeleteRuleNew2Data = any;

export interface RulesGetSelectedImprovementsParams {
    providerName?: string | null;
    businessUnitId?: string | null;
    tenantId: string;
}

export type RulesGetSelectedImprovementsData = SelectedImprovements;

export interface RulesGetSelectedImprovements2Params {
    providerName?: string | null;
    businessUnitId?: string | null;
    tenantId: string;
}

export type RulesGetSelectedImprovements2Data = SelectedImprovements;

import { inject, injectable, optional, symbolToken } from '@servicetitan/react-ioc';
import axios, { AxiosRequestConfig, AxiosResponse, ResponseType } from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { RequestOrigin, type EntryPoint, type SourceMfe } from './request-attribution';
export { RequestOrigin } from './request-attribution';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<
    AxiosRequestConfig,
    'data' | 'params' | 'url' | 'responseType'
> {
    /** set parameter to `true` for call `securityWorker` for this request */
    secure?: boolean;
    /** request path */
    path: string;
    /** content type of request body */
    type?: ContentType;
    /** query params */
    query?: QueryParamsType;
    /** format of response (i.e. response.json() -> format: "json") */
    format?: ResponseType;
    /** request body */
    body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export enum ContentType {
    Json = 'application/json',
    FormData = 'multipart/form-data',
    UrlEncoded = 'application/x-www-form-urlencoded',
    Text = 'text/plain',
}

@injectable()
export class HttpClient {
    sessionId: string;
    tenantId: string;
    tenantFriendlyName: string;
    actingUserId: string;
    requestOrigin: RequestOrigin;
    entryPoint?: EntryPoint;
    sourceMfe?: SourceMfe;
    financingProvider: string = 'Unspecified';

    constructor(
        sessionId: string,
        tenantId: string,
        tenantFriendlyName: string,
        actingUserId: string,
        requestOrigin: RequestOrigin,
        entryPoint?: EntryPoint,
        sourceMfe?: SourceMfe,
    ) {
        this.sessionId = sessionId;
        this.tenantId = tenantId;
        this.tenantFriendlyName = tenantFriendlyName;
        this.actingUserId = actingUserId;
        this.requestOrigin = requestOrigin;
        this.entryPoint = entryPoint;
        this.sourceMfe = sourceMfe;
    }

    public setFinancingProvider(provider: string) {
        this.financingProvider = provider;
    }

    protected stringifyFormItem(formItem: unknown) {
        if (typeof formItem === 'object' && formItem !== null) {
            return JSON.stringify(formItem);
        } else {
            return `${formItem}`;
        }
    }

    protected createFormData(input: Record<string, unknown>): FormData {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            const propertyContent: any[] = property instanceof Array ? property : [property];

            for (const formItem of propertyContent) {
                const isFileType = formItem instanceof Blob || formItem instanceof File;
                formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
            }

            return formData;
        }, new FormData());
    }

    public request = async <T = any, _E = any>({
        secure,
        path,
        type,
        query,
        format,
        body,
        ...params
    }: FullRequestParams): Promise<AxiosResponse<T>> => {
        const responseFormat = format;

        if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
            body = this.createFormData(body as Record<string, unknown>);
        }

        if (type === ContentType.Text && body && body !== null && typeof body !== 'string') {
            body = JSON.stringify(body);
        }

        return axios.request({
            ...params,
            headers: {
                ...(params.headers || {}),
                ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
                'X-ST-SessionId': this.sessionId,
                'X-ST-CorrelationId': uuidv4(),
                'X-ST-TenantId': this.tenantId,
                'X-ST-TenantFriendlyName': this.tenantFriendlyName,
                'X-ST-ActingUserId': this.actingUserId,
                'X-ST-FIN-Origin': this.requestOrigin,
                'X-ST-FIN-Provider': this.financingProvider,
                ...(this.entryPoint ? { 'X-ST-FIN-EntryPoint': this.entryPoint } : {}),
                ...(this.sourceMfe ? { 'X-ST-FIN-SourceMfe': this.sourceMfe } : {}),
            },
            params: query,
            responseType: responseFormat,
            data: body,
            url: path,
            paramsSerializer: { indexes: null },
        });
    };
}

export const SESSION_ID_FinPlansApi = symbolToken<string>('SESSION_ID', false);
export const TENANT_ID_FinPlansApi = symbolToken<string>('TENANT_ID', false);
export const TENANT_FRIENDLY_NAME_FinPlansApi = symbolToken<string>('TENANT_FRIENDLY_NAME', false);
export const ACTING_USER_ID_FinPlansApi = symbolToken<string>('ACTING_USER_ID', false);
export const REQUEST_ORIGIN_FinPlansApi = symbolToken<string>('REQUEST_ORIGIN', false);
export const ENTRY_POINT_FinPlansApi = symbolToken<string>('ENTRY_POINT', false);
export const SOURCE_MFE_FinPlansApi = symbolToken<string>('SOURCE_MFE', false);

export const BASE_URL_TOKEN_FinPlansApi = symbolToken<string>('BASE_URL_TOKEN', false);

/**
 * @title Financing Plans Service with payment calculations
 * @version v1
 * @baseUrl http://localhost:18110
 */
@injectable()
export class FinPlansApi extends HttpClient {
    constructor(
        @inject(SESSION_ID_FinPlansApi) @optional() sessionId: string,
        @inject(TENANT_ID_FinPlansApi) @optional() tenantId: string,
        @inject(TENANT_FRIENDLY_NAME_FinPlansApi) @optional() tenantFriendlyName: string,
        @inject(ACTING_USER_ID_FinPlansApi) @optional() actingUserId: string,
        @inject(REQUEST_ORIGIN_FinPlansApi) @optional() requestOrigin: RequestOrigin,
        @inject(ENTRY_POINT_FinPlansApi) @optional() entryPoint: EntryPoint,
        @inject(SOURCE_MFE_FinPlansApi) @optional() sourceMfe: SourceMfe,
        @inject(BASE_URL_TOKEN_FinPlansApi) @optional() private readonly baseUrl = '',
    ) {
        super(sessionId, tenantId, tenantFriendlyName, actingUserId, requestOrigin, entryPoint, sourceMfe);
    }

    public setFinancingProvider(provider: string): void {
        super.setFinancingProvider(provider);
    }

    /**
     * No description
     *
     * @tags Metrics
     * @name MetricsExportMetricsAsInSample
     * @request GET:/metrics/-exported
     * @secure
     */
    metricsExportMetricsAsInSample = (params: RequestParams = {}) =>
        this.request<MetricsExportMetricsAsInSampleData, any>({
            path: `/metrics/-exported`,
            method: 'GET',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Metrics
     * @name MetricsExportMetricsAsInDocs
     * @request GET:/metrics
     * @secure
     */
    metricsExportMetricsAsInDocs = (params: RequestParams = {}) =>
        this.request<MetricsExportMetricsAsInDocsData, any>({
            path: `/metrics`,
            method: 'GET',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Status
     * @name StatusGet
     * @summary An easy way to run health checks
     * @request GET:/status
     * @secure
     */
    statusGet = (params: RequestParams = {}) =>
        this.request<StatusGetData, void>({
            path: `/status`,
            method: 'GET',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Status
     * @name StatusMetrics
     * @request GET:/status/metrics
     * @secure
     */
    statusMetrics = (params: RequestParams = {}) =>
        this.request<StatusMetricsData, any>({
            path: `/status/metrics`,
            method: 'GET',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Status
     * @name StatusGet2
     * @summary An easy way to run health checks
     * @request GET:/ctatyc
     * @secure
     */
    statusGet2 = (params: RequestParams = {}) =>
        this.request<StatusGet2Data, void>({
            path: `/ctatyc`,
            method: 'GET',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Status
     * @name StatusMetrics2
     * @request GET:/ctatyc/metrics
     * @secure
     */
    statusMetrics2 = (params: RequestParams = {}) =>
        this.request<StatusMetrics2Data, any>({
            path: `/ctatyc/metrics`,
            method: 'GET',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Calculations
     * @name CalculationsGetCalculations
     * @summary Get financing calculations for a given loan amount and provider.
     * @request GET:/v1/calculations
     * @secure
     */
    calculationsGetCalculations = (
        query: CalculationsGetCalculationsParams,
        params: RequestParams = {},
    ) =>
        this.request<CalculationsGetCalculationsData, CalculationsGetCalculationsError>({
            path: `/v1/calculations`,
            method: 'GET',
            baseURL: this.baseUrl,
            query: query,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Calculations
     * @name CalculationsGetCalculations2
     * @summary Get financing calculations for a given loan amount and provider.
     * @request GET:/v1/loans/calculations
     * @secure
     */
    calculationsGetCalculations2 = (
        query: CalculationsGetCalculations2Params,
        params: RequestParams = {},
    ) =>
        this.request<CalculationsGetCalculations2Data, CalculationsGetCalculations2Error>({
            path: `/v1/loans/calculations`,
            method: 'GET',
            baseURL: this.baseUrl,
            query: query,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Improvements
     * @name ImprovementsGetSelectedImprovements
     * @summary Returns the saved selected products for the tenant and the provider.
     * @request GET:/v1/improvements
     * @secure
     */
    improvementsGetSelectedImprovements = (
        query: ImprovementsGetSelectedImprovementsParams,
        params: RequestParams = {},
    ) =>
        this.request<ImprovementsGetSelectedImprovementsData, void>({
            path: `/v1/improvements`,
            method: 'GET',
            baseURL: this.baseUrl,
            query: query,
            secure: true,
            ...params,
        });

    /**
     * @description For Affirm accounts, the Properties field may optionally include an estimate range (amounts in dollars): - minEstimateAmount: lower bound below which Affirm financing is not offered (e.g. "100.00") - maxEstimateAmount: upper bound above which Affirm financing is not offered (e.g. "10000.00") The range is optional: omit both keys (or send them blank) to clear it, in which case the range gate is inactive. When provided, both keys are required together and must be non-negative decimals with min < max; otherwise returns 422.
     *
     * @tags Accounts
     * @name AccountsSaveAccount
     * @summary Save account with MerchantAccounts. Validates that no active rules reference MIDs being removed.
     * @request PUT:/v1/accounts/tenants/{tenantId}
     * @secure
     */
    accountsSaveAccount = (
        { tenantId, ...query }: AccountsSaveAccountParams,
        data: TenantAccountBase,
        params: RequestParams = {},
    ) =>
        this.request<AccountsSaveAccountData, AccountsSaveAccountError>({
            path: `/v1/accounts/tenants/${tenantId}`,
            method: 'PUT',
            baseURL: this.baseUrl,
            query: query,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * No description
     *
     * @tags Providers
     * @name ProvidersGetPlans
     * @summary List all plans available for the specified financing provider.
     * @request GET:/v1/providers/{providerName}/plans
     * @secure
     */
    providersGetPlans = (
        { providerName, ...query }: ProvidersGetPlansParams,
        params: RequestParams = {},
    ) =>
        this.request<ProvidersGetPlansData, ProvidersGetPlansError>({
            path: `/v1/providers/${providerName}/plans`,
            method: 'GET',
            baseURL: this.baseUrl,
            query: query,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags RuleRecommendations
     * @name RuleRecommendationsGetRuleRecommendations
     * @summary Get the list of available rule recommendations from the Plan Optimizer.
     * @request GET:/v1/rule-recommendations
     * @secure
     */
    ruleRecommendationsGetRuleRecommendations = (
        query: RuleRecommendationsGetRuleRecommendationsParams,
        params: RequestParams = {},
    ) =>
        this.request<RuleRecommendationsGetRuleRecommendationsData, void>({
            path: `/v1/rule-recommendations`,
            method: 'GET',
            baseURL: this.baseUrl,
            query: query,
            secure: true,
            ...params,
        });

    /**
     * @description This endpoint triggers asynchronous recommendation generation. Use GET /rule-recommendations to retrieve results after processing completes.
     *
     * @tags RuleRecommendations
     * @name RuleRecommendationsTriggerRuleRecommendations
     * @summary Generate (or re-generate) rule recommendations for the Plan Optimizer.
     * @request POST:/v1/rule-recommendations
     * @secure
     */
    ruleRecommendationsTriggerRuleRecommendations = (
        data: TriggerRuleRecommendation,
        params: RequestParams = {},
    ) =>
        this.request<
            RuleRecommendationsTriggerRuleRecommendationsData,
            RuleRecommendationsTriggerRuleRecommendationsError
        >({
            path: `/v1/rule-recommendations`,
            method: 'POST',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * No description
     *
     * @tags RuleRecommendations
     * @name RuleRecommendationsUpsertRuleRecommendations
     * @summary Upserts a set of rule recommendations.
     * @request PUT:/v1/rule-recommendations
     * @secure
     */
    ruleRecommendationsUpsertRuleRecommendations = (
        data: RuleRecommendationsUpsertRuleRecommendationsPayload,
        params: RequestParams = {},
    ) =>
        this.request<
            RuleRecommendationsUpsertRuleRecommendationsData,
            RuleRecommendationsUpsertRuleRecommendationsError
        >({
            path: `/v1/rule-recommendations`,
            method: 'PUT',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * No description
     *
     * @tags Rules
     * @name RulesGetRules
     * @request GET:/v1/rules/rules
     * @secure
     */
    rulesGetRules = (query: RulesGetRulesParams, params: RequestParams = {}) =>
        this.request<RulesGetRulesData, void>({
            path: `/v1/rules/rules`,
            method: 'GET',
            baseURL: this.baseUrl,
            query: query,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Rules
     * @name RulesCreateRuleNew
     * @request POST:/v1/rules/rules
     * @secure
     */
    rulesCreateRuleNew = (data: CreateRule, params: RequestParams = {}) =>
        this.request<RulesCreateRuleNewData, RulesCreateRuleNewError>({
            path: `/v1/rules/rules`,
            method: 'POST',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * No description
     *
     * @tags Rules
     * @name RulesGetRules2
     * @request GET:/v1/rules
     * @secure
     */
    rulesGetRules2 = (query: RulesGetRules2Params, params: RequestParams = {}) =>
        this.request<RulesGetRules2Data, void>({
            path: `/v1/rules`,
            method: 'GET',
            baseURL: this.baseUrl,
            query: query,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Rules
     * @name RulesCreateRuleNew2
     * @request POST:/v1/rules
     * @secure
     */
    rulesCreateRuleNew2 = (data: CreateRule, params: RequestParams = {}) =>
        this.request<RulesCreateRuleNew2Data, RulesCreateRuleNew2Error>({
            path: `/v1/rules`,
            method: 'POST',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * No description
     *
     * @tags Rules
     * @name RulesGetRuleNew
     * @request GET:/v1/rules/rules/{id}
     * @secure
     */
    rulesGetRuleNew = (id: string, params: RequestParams = {}) =>
        this.request<RulesGetRuleNewData, void>({
            path: `/v1/rules/rules/${id}`,
            method: 'GET',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Rules
     * @name RulesUpdateRuleNew
     * @request PUT:/v1/rules/rules/{id}
     * @secure
     */
    rulesUpdateRuleNew = (id: string, data: UpdateRule, params: RequestParams = {}) =>
        this.request<RulesUpdateRuleNewData, RulesUpdateRuleNewError>({
            path: `/v1/rules/rules/${id}`,
            method: 'PUT',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * No description
     *
     * @tags Rules
     * @name RulesDeleteRuleNew
     * @request DELETE:/v1/rules/rules/{id}
     * @secure
     */
    rulesDeleteRuleNew = (id: string, params: RequestParams = {}) =>
        this.request<RulesDeleteRuleNewData, void>({
            path: `/v1/rules/rules/${id}`,
            method: 'DELETE',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Rules
     * @name RulesGetRuleNew2
     * @request GET:/v1/rules/{id}
     * @secure
     */
    rulesGetRuleNew2 = (id: string, params: RequestParams = {}) =>
        this.request<RulesGetRuleNew2Data, void>({
            path: `/v1/rules/${id}`,
            method: 'GET',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Rules
     * @name RulesUpdateRuleNew2
     * @request PUT:/v1/rules/{id}
     * @secure
     */
    rulesUpdateRuleNew2 = (id: string, data: UpdateRule, params: RequestParams = {}) =>
        this.request<RulesUpdateRuleNew2Data, RulesUpdateRuleNew2Error>({
            path: `/v1/rules/${id}`,
            method: 'PUT',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * No description
     *
     * @tags Rules
     * @name RulesDeleteRuleNew2
     * @request DELETE:/v1/rules/{id}
     * @secure
     */
    rulesDeleteRuleNew2 = (id: string, params: RequestParams = {}) =>
        this.request<RulesDeleteRuleNew2Data, void>({
            path: `/v1/rules/${id}`,
            method: 'DELETE',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Rules
     * @name RulesGetSelectedImprovements
     * @request GET:/v1/rules/rules/{tenantId}/improvements
     * @secure
     */
    rulesGetSelectedImprovements = (
        { tenantId, ...query }: RulesGetSelectedImprovementsParams,
        params: RequestParams = {},
    ) =>
        this.request<RulesGetSelectedImprovementsData, void>({
            path: `/v1/rules/rules/${tenantId}/improvements`,
            method: 'GET',
            baseURL: this.baseUrl,
            query: query,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Rules
     * @name RulesGetSelectedImprovements2
     * @request GET:/v1/rules/{tenantId}/improvements
     * @secure
     */
    rulesGetSelectedImprovements2 = (
        { tenantId, ...query }: RulesGetSelectedImprovements2Params,
        params: RequestParams = {},
    ) =>
        this.request<RulesGetSelectedImprovements2Data, void>({
            path: `/v1/rules/${tenantId}/improvements`,
            method: 'GET',
            baseURL: this.baseUrl,
            query: query,
            secure: true,
            ...params,
        });
}
